import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const CrossIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.974 8L14.58 3.394C14.846 3.142 15 2.792 15 2.4C15 1.63 14.37 1 13.6 1C13.208 1 12.858 1.154 12.606 1.406L8 6.026L3.394 1.406C3.142 1.154 2.792 1 2.4 1C1.63 1 1 1.63 1 2.4C1 2.792 1.154 3.142 1.406 3.394L6.026 8L1.42 12.606C1.154 12.858 1 13.208 1 13.6C1 14.37 1.63 15 2.4 15C2.792 15 3.142 14.846 3.394 14.594L8 9.974L12.606 14.58C12.858 14.846 13.208 15 13.6 15C14.37 15 15 14.37 15 13.6C15 13.208 14.846 12.858 14.594 12.606L9.974 8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CrossIcon;
